import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { initSentry } from './lib/sentry'
import App from './App.tsx'
import './index.css'

initSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ padding: 24 }}>Something went wrong. Refresh to try again.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
